import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  show = false;
  loading = false;
  #observers = [];

  agency = '';
  login = '';
  password = '';

  pageLogin = '/tourclient/login/';

  init(data) {
    this.agency = data.AgencyId;
    this.login = data.Login;
  }

  redirect() {
    window.location.href = `${this.pageLogin}?ret=${encodeURIComponent(window.location.href)}`;
  }

  open() {
    if (!this.agency && !this.login) {
      this.redirect();
      return Promise.reject();
    }
    return new Promise((resolve) => {
      this.#observers.push(resolve);
      if (this.show) {
        return;
      }
      this.show = true;
    });
  }

  submit() {
    this.loading = true;
    return this.api
      .post('/tourclient/account/loginajax', {
        partnerId: this.agency,
        login: this.login,
        password: this.password,
      })
      .then((data) => {
        switch (data.Status) {
          case null:
          case 0:
            return true;
          case 2:
            return Promise.reject('Превышено максимальное количество активных подключений');
          case 3:
            return Promise.reject('Неверный логин или пароль');
          case 4:
            return Promise.reject('Агентство не существует');
          case 5:
            return Promise.reject('Вам запрещен вход в систему');
          case 6:
            return Promise.reject('Необходимо указать новый пароль');
          default:
            return Promise.reject('В данный момент сервис недоступен');
        }
      })
      .then(() => {
        this.#observers.forEach(i => i(this));
        this.#observers = [];
        this.show = false;
        return true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  logout() {
    this.parent.loading = true;
    return this.api
      .get(`/tourclient/account/logout?_=${Date.now()}`)
      .then(() => {
        window.location.href = this.pageLogin;
        return true;
      })
      .finally(() => {
        this.parent.loading = false;
      });
  }
}
